import { Field } from '@progress/kendo-react-form';
import { useFileUploadValidator, useUploadDocuments } from 'hooks';
import { DialogProps, DisputeDialog, DisputeEventResult, FieldInput, FileUpload, Label } from 'components';
import { DisputeEventTypes } from 'enums';
import styles from './AddDocumentation.module.scss';

/**
 * AddDocumentation component allows the supplier to attach documents to the dispute.
 * 
 * @param props - Additional properties passed to the Dialog
 * @returns Rendered component
 */

export type DocumentationProps = {
    /**
     * Indicate if document is a Dot Provided Documenation
     */
    isDotProvided?: boolean
} & DialogProps;

export const AddDocumentation = (props: DocumentationProps) => {
    const filesValidator = useFileUploadValidator(1);
    const uploadDocuments = useUploadDocuments();

    const onSubmit = async (data: any) => {
        const { disputeNumber, files,  ...rest } = data;

        if (!(files?.length > 0)) {
            return {
                error: 'Please provide additional documentation'
            } as DisputeEventResult;
        }

        const fileData = files?.map((file: any) => file.getRawFile()) ?? [];
        
        const result = await uploadDocuments.uploadFiles(disputeNumber, {
            ...rest,
            isDotProvided: props.isDotProvided,
            eventTypeId: DisputeEventTypes.DocumentAdded,
        }, fileData);

        return {
            error: !result?.status && 'Error adding documentation'
        } as DisputeEventResult;
    };

    return (
        <DisputeDialog
            title="Upload Documentation"
            showIsPublic={false}
            showNoteLabel={false}
            submitLabel="Submit"
            onSubmit={onSubmit}
            {...props}
        >
            <Label className={styles.label2} required>Additional Documentation</Label>
            <Field
                component={FieldInput}
                child={FileUpload}
                label="Please provide any additional documentation."
                name="files"
                required
                validator={filesValidator}
            />
            <Label className={styles.label2} required>Comments</Label>
            <p>Please provide any additional information about the disputed adjustments.</p>
        </DisputeDialog>
    )
};